import {
  SEARCH_TRACKINGS,
  SEARCH_TRACKINGS_SUCCESS,
  SEARCH_TRACKINGS_ERROR,
  SEARCH_SAVE_KEYWORD,
  RESET_SEARCH_TRACKINGS_FLAG,
} from "./actionTypes"

export const searchTrackings = keyword => {
  return {
    type: SEARCH_TRACKINGS,
    payload: { keyword },
  }
}

export const searchTrackingsSuccess = trackings => {
  return {
    type: SEARCH_TRACKINGS_SUCCESS,
    payload: { trackings },
  }
}

export const searchTrackingsError = error => {
  return {
    type: SEARCH_TRACKINGS_ERROR,
    payload: error,
  }
}

export const searchSaveKeyword = keyword => {
  return {
    type: SEARCH_SAVE_KEYWORD,
    payload: keyword,
  }
}

export const resetSearchTrackingFlag = () => {
  return {
    type: RESET_SEARCH_TRACKINGS_FLAG,
  }
}
